import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  z-index: 1;\n\n  ', ';\n'], ['\n  position: relative;\n  z-index: 1;\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    opacity: 0;\n  '], ['\n    opacity: 0;\n  ']);

import styled from 'styled-components';
import { whenCollapsed } from '../../theme/util';

var NavigationItemTextAfter = styled.div(_templateObject, whenCollapsed(_templateObject2));

NavigationItemTextAfter.displayName = 'NavigationItemTextAfter';
export default NavigationItemTextAfter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/NavigationItemTextAfter.js
// module id = 633
// module chunks = 0